import React from 'react'

export const Check =() => {
    return (
        <svg
            style={{color: '#81B443'}}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            className="feather feather-check-circle"
            viewBox="0 0 24 24"
            >
            <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
            <path d="M22 4L12 14.01 9 11.01"></path>
        </svg>
    )
}



export const Pie =() => {
    return (
        <svg
            style={{color: 'green'}}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            className="feather feather-pie-chart"
            viewBox="0 0 24 24"
            >
            <path d="M21.21 15.89A10 10 0 118 2.83M22 12A10 10 0 0012 2v10z"></path>
        </svg>
    )
}



export const Bag =() => {
    return (
        <svg
            style={{color: '#1976d2'}}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            className="feather feather-shopping-bag"
            viewBox="0 0 24 24"
            >
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"></path>
            <path d="M3 6L21 6"></path>
            <path d="M16 10a4 4 0 01-8 0"></path>
        </svg>
    )
}




export const Card =() => {
    return (
        <svg
            style={{color: 'green'}}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            className="feather feather-credit-card"
            viewBox="0 0 24 24"
            >
            <rect width="22" height="16" x="1" y="4" rx="2" ry="2"></rect>
            <path d="M1 10L23 10"></path>
        </svg>
    )
}



export const Clock =() => {
    return(
        <svg
        style={{color: 'red'}}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className="feather feather-clock"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M12 6L12 12 16 14"></path>
    </svg>
    )
}

export const Frown = () => {
    return(
        <svg
        style={{color: 'red'}}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className="feather feather-frown"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M16 16s-1.5-2-4-2-4 2-4 2"></path>
      <path d="M9 9L9.01 9"></path>
      <path d="M15 9L15.01 9"></path>
    </svg>
    )
}